/// <amd-module name="Test/TestPlansHubRefresh/TestPlanCloneProgress/Redux/TestPlanCloneProgressSaga" />
import { effects, SagaIterator } from "redux-saga";
import { ActionsOfType } from "redux/Utils/ActionHelper";
import { ITestHubDataService } from "Test/TestPlansHubRefresh/Service/TestHubDataService";
import { CloneTestPlanOperationInformation } from "TestPlanCommon/Contracts/TestPlan";
import { IVssPageContext } from "VSS/Platform/Context";
import { SuitesActions } from "Test/TestPlansHubRefresh/TestHub/Redux/Suites/SuitesActions";
import { TestHubRefreshConstants } from "Test/TestPlansHubRefresh/TestHub/Constants";
import { TestPlanCloneProgressActions, TestPlanCloneProgressActionsTypes } from "./TestPlanCloneProgressActions";
import { CloneOperationState } from "./TestPlanCloneProgressContracts";
import * as Resources from "Test/TestPlansHubRefresh/TestHub/Resources";
import { errorHandledSaga } from "Test/TestPlansHubRefresh/TestHub/Util";

export function* TestPlanCloneProgressSaga(): SagaIterator {
    yield effects.takeLatest(TestPlanCloneProgressActionsTypes.getCloneOpState, _getCloneOpState);
}

export function* getCloneOpState(action: ActionsOfType<TestPlanCloneProgressActions, TestPlanCloneProgressActionsTypes.getCloneOpState>): SagaIterator {
    try {
        const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
        const dataService: ITestHubDataService = (yield effects.call([pageContext, pageContext.getService], "ITestHubDataService")) as any;
        // initial call is to determine the first call as we need to show the spinner on the first call.
        if (action.payload.initialCall) {
            yield effects.put(SuitesActions.updateLoadingStatus(true));
        }

        let cloneTestPlanOperationInformation: CloneTestPlanOperationInformation = (yield effects.call(
            [dataService, dataService.getCloneInformation],
            action.payload.opId
        )) as any;
        let state: CloneOperationState = CloneOperationState.Queued;
        let message: string = "";
        if (cloneTestPlanOperationInformation && cloneTestPlanOperationInformation.cloneOperationResponse) {
            state = cloneTestPlanOperationInformation.cloneOperationResponse.state;
            if (state == CloneOperationState.Failed) {
                message = cloneTestPlanOperationInformation.cloneOperationResponse.message;
                yield effects.put(SuitesActions.showToastNotifications(Resources.CloneOperationFailed + " " + message, TestHubRefreshConstants.ERROR_TOAST_DURATION, undefined, undefined, "clone-progress-toast"));
            }
        }

        yield effects.put(TestPlanCloneProgressActions.loadCloneOpStateSucceeded(state));
        if (state !== CloneOperationState.Succeeded) {
            yield effects.delay(5000);
            yield effects.put(TestPlanCloneProgressActions.getCloneOpState(action.payload.planId, action.payload.opId, false));
        } else {
            yield effects.put(SuitesActions.reloadTestPlanAndSuites(action.payload.planId));
        }
    } catch { }
}

const _getCloneOpState = errorHandledSaga(function* (
    action: ActionsOfType<TestPlanCloneProgressActions, TestPlanCloneProgressActionsTypes.getCloneOpState>
): SagaIterator {
    yield effects.call(getCloneOpState, action);
});
